import { AUDIT_TRAIL_ACCESS, SETTINGS_ACCESS } from "config/access-control";

export const mainDrawerOptions = [
  { text: "hospital setup", to: "/dashboard/settings/" },
  { text: "branches", to: "/dashboard/settings/" },
  { text: "departments", to: "/dashboard/settings/" },
  { text: "roles", to: "/dashboard/settings/" },
  { text: "staff management", to: "/dashboard/settings/" },
  { text: "system configuration", to: "/dashboard/settings/" },
  { text: "appointments", to: "/dashboard/settings/" },
  { text: `hmo`.toUpperCase(), to: "/dashboard/settings/" },
  { text: "medical standards", to: "/dashboard/settings/" },
];

export const setupOptions = [
  { text: "hospital setup", to: "/onboarding/configuration/hospital-setup" },
  {
    text: "branches",
    to: "/onboarding/configuration/branches",
    required: true,
  },
  {
    text: "departments",
    to: "/onboarding/configuration/departments",
    required: true,
  },
  { text: "roles", to: "/onboarding/configuration/roles", required: true },
  {
    text: "system configuration",
    to: "/onboarding/configuration/system-configuration",
    required: true,
  },
  {
    text: "staff management",
    to: "/onboarding/configuration/staff-management",
    required: true,
  },
  { text: `hmo`.toUpperCase(), to: "/onboarding/configuration/hmo" },
  {
    text: "medical standards",
    to: "/onboarding/configuration/medical-standards",
  },
  { text: "appointments", to: "/onboarding/configuration/appointments" },
];

export const auditTrailNavOptions = () => {
  const sidebarOptions = [
    {
      icon: "audit-trail",
      text: "Audit Trail",
      to: "/audit-trail",
      permissions: AUDIT_TRAIL_ACCESS,
    },
  ];
  return sidebarOptions;
};

export const labsNavOptions = () => {
  const sidebarOptions = [
    {
      text: "Report",
      icon: "report",
      to: "/laboratory/report",
      permissions: ["view-task", "manage-task", "super-view"],
    },
    {
      text: "Board",
      icon: "kanban",
      to: "/laboratory/task-management",
      permissions: ["view-task", "manage-task", "super-view"],
    },
    {
      text: "Backlog",
      icon: "inbox",
      to: "/laboratory/backlog",
      permissions: ["view-task", "manage-task", "super-view"],
    },
    {
      text: "Orders List",
      icon: "list-ordered",
      to: "/laboratory/orders-list",
      permissions: ["view-task", "manage-task", "super-view"],
    },
  ];
  return sidebarOptions;
};

export const inventoryNavOptions = (isParent) => {
  const sidebarOptions = [
    {
      text: "Stock Item.",
      icon: "inventory",
      to: "/inventory/stock?tab=stock-items",
      permissions: ["view-item", "manage-item", "view-stock", "manage-stock", "super-view"],
    },
    {
      text: "Services",
      icon: "services",
      to: "/inventory/services",
      permissions: ["view-item", "manage-item", "super-view"],
    },
    {
      text: "HMO",
      icon: "insurance",
      to: "/inventory/hmo",
      permissions: ["view-sponsor", "manage-sponsor", "view-item", "manage-item", "super-view"],
    },
  ];
  if (isParent) {
    sidebarOptions.push({
      text: "Central Store Settings",
      icon: "frontdesk-settings",
      to: "/inventory/settings",
      permissions: ["manage-item", "manage-stock", "super-view"],
    });
  }

  return sidebarOptions;
};

export const centralStoreNavOptions = () => {
  const sidebarOptions = [
    {
      text: "Stock Item.",
      icon: "inventory",
      to: "/central-store/stock?tab=stock-items",
      permissions: ["view-item", "manage-item", "view-stock", "manage-stock", "super-view"],
    },
    {
      text: "Services",
      icon: "services",
      to: "/central-store/services",
      permissions: ["view-item", "manage-item", "super-view"],
    },
    {
      text: "HMO",
      icon: "insurance",
      to: "/central-store/hmo",
      permissions: ["view-sponsor", "manage-sponsor", "view-item", "manage-item", "super-view"],
    },
  ];
  return sidebarOptions;
};

export const frontDeskNavOptions = () => {
  const sidebarOptions = [
    {
      text: "Dashboard",
      icon: "dashboard-fd",
      to: "/frontdesk/dashboard",
      permissions: ["view-appointment", "manage-appointment", "view-patient", "manage-patient", "super-view"],
    },
    {
      text: "Patients",
      icon: "patient-list",
      to: "/frontdesk/patients",
      permissions: ["view-patient", "manage-patient", "create-patient", "super-view"],
    },
    {
      text: "Appointments",
      icon: "appointments-setup",
      to: "/frontdesk/appointments",
      permissions: ["view-appointment", "manage-appointment", "create-appointment", "super-view"],
    },
    {
      text: "Calendar",
      icon: "calendar",
      to: "/frontdesk/calendar",
      permissions: ["view-appointment", "manage-appointment", "super-view"],
    },
  ];
  return sidebarOptions;
};

export const clinicNavOptions = (module) => {
  const sidebarOptions = [
    {
      text: "Dashboard",
      icon: "dashboard-fd",
      to: `/${module}/dashboard`,
    },
    {
      text: "Patients",
      icon: "patient-list",
      to: `/${module}/patients`,
    },
    module === "out-patient"
      ? {
        text: "Appointments",
        icon: "appointments-setup",
        to: `/${module}/appointments`,
      }
      : undefined,
    {
      text: "Calendar",
      icon: "calendar",
      to: `/${module}/calendar`,
    },
  ].filter((e) => e !== undefined);
  return sidebarOptions;
};

export const deskNavOptions = () => {
  const sidebarOptions = [
    {
      text: "dashboard",
      icon: "dashboard",
      to: "/frontdesk/dashboard",
    },
    {
      text: "patients",
      icon: "backlog",
      to: "/frontdesk/patients",
    },
  ];
  return sidebarOptions;
};

export const settingsNavOptions = () => {
  const sidebarOptions = [
    {
      text: "Hospital Setup",
      icon: "hospital",
      to: "/settings/hospital-setup",
      permissions: SETTINGS_ACCESS.hospitalSetup,
    },
    {
      text: "Branch",
      icon: "branch-config",
      to: "/settings/branches",
      permissions: SETTINGS_ACCESS.branches,
      isMigrated: true,
    },
    {
      text: "Department",
      icon: "department",
      to: "/settings/departments",
      permissions: SETTINGS_ACCESS.departments,
      isMigrated: true,
    },
    {
      text: "Staff",
      icon: "staff",
      to: "/settings/staff",
      permissions: SETTINGS_ACCESS.staff,
      isMigrated: true,
    },
  ];

  const dashboardLinks = [
    {
      text: "Patient Health",
      icon: "vital-signs",
      to: "/settings/dashboard/patient-health",
      permissions: SETTINGS_ACCESS.dashboards,
    },
    {
      text: "Hospital Performance",
      icon: "insight",
      to: "/settings/dashboard/hospital-performance",
      permissions: SETTINGS_ACCESS.dashboards,
    },
    {
      text: "Financial Revenue",
      icon: "wallet",
      to: "/settings/dashboard/financial-revenue",
      permissions: SETTINGS_ACCESS.dashboards,
    },
    {
      text: "InventorySettings Management",
      icon: "inventory",
      to: "/settings/dashboard/inventory-management",
      permissions: SETTINGS_ACCESS.dashboards,
    }
  ];

  let moreLinks = [
    {
      text: "Sponsors",
      to: "/settings/sponsors",
      permissions: SETTINGS_ACCESS.sponsors,
      isMigrated: true,
    },

    {
      text: "Patients List",
      to: "/settings/patients",
      permissions: SETTINGS_ACCESS.patients,
      isMigrated: true,
    },
    {
      text: "Branch configuration",
      to: "/settings/branch-config",
      permissions: SETTINGS_ACCESS.branchConfig,
    },
    {
      text: "Plan",
      to: "/settings/plans",
      permissions: SETTINGS_ACCESS.plans,
    },
    {
      text: "banks",
      to: "/settings/banks",
      permissions: SETTINGS_ACCESS.banks,
    },
    {
      text: "Categories",
      to: "/settings/categories",
      permissions: SETTINGS_ACCESS.categories,
    },
    {
      text: "Registration Customization",
      to: "/settings/reg-custom",
      permissions: SETTINGS_ACCESS.registrationCustomization,
    },
    // {
    //   text: "Data Library",
    //   to: "/settings/medic-standard",
    // },
    {
      text: "Admission Mgt",
      to: "/settings/admission-mgt",
      permissions: SETTINGS_ACCESS.admissionManagement,
      isMigrated: true,
    },
    {
      text: "Roles",
      to: "/settings/roles",
      permissions: SETTINGS_ACCESS.roles,
    },
    {
      text: "Bulk Uploads",
      to: "/settings/bulk-uploads",
      permissions: SETTINGS_ACCESS.bulkUploads,
    },
    {
      text: "License",
      to: "/settings/license",
      permissions: SETTINGS_ACCESS.license,
    },
    { text: "Forms", to: "/settings/forms", permissions: SETTINGS_ACCESS.forms },
    {
      text: "Data Library",
      to: "/settings/data-library",
      permissions: SETTINGS_ACCESS.dataLibrary,
      isMigrated: true,
    },
    {
      text: "Integrations",
      to: "/settings/integrations",
      permissions: SETTINGS_ACCESS.integrations,
      isMigrated: true,
    },
    {
      text: "Partnership",
      to: "/settings/partnership",
      permissions: SETTINGS_ACCESS.partnership,
      isMigrated: true,
    },
  ];
  return { sidebarOptions, moreLinks, dashboardLinks };
};

export const pharmacyNavOptions = (isProduction) => {
  const sidebarOptions = [
    {
      text: "Dashboard",
      icon: "dashboard-fd",
      to: "/pharmacy",
      permissions: ["view-prescription", "manage-prescription", "super-view"],
      isMigrated: true,
    },
    {
      text: "Patients",
      icon: "patient-list",
      to: "/pharmacy/patients",
      permissions: ["view-patient", "view-prescription", "manage-prescription", "super-view"],
      isMigrated: true,
    },
    {
      text: "Sales point",
      icon: "pharmacy-presc",
      to: "/pharmacy/sales",
      permissions: ["view-prescription", "manage-prescription", "create-prescription", "super-view"],
      isMigrated: true,
    },
    // TODO: Re-enable Pharmacy Insight nav item when Insight is restored.
    // {
    //   text: "Insight",
    //   icon: "insight",
    //   to: "/pharmacy/insight",
    // },
  ];

  if (!isProduction) {
    sidebarOptions.splice(2, 0, {
      text: "Retail",
      icon: "retail",
      to: "/pharmacy/retail",
      permissions: ["view-item", "manage-item", "create-bill", "super-view"],
      isMigrated: true,
    });
  }
  return sidebarOptions;
};

export const billingNavOptions = () => {
  const sidebarOptions = [
    {
      text: "Dashboard",
      icon: "dashboard-fd",
      to: "/billing/dashboard",
      permissions: ["view-bill", "manage-bill", "create-payment", "super-view"],
    },
    {
      text: "Patients",
      icon: "patients",
      to: "/billing/patients",
      permissions: ["view-patient", "manage-patient", "view-bill", "manage-bill", "super-view"],
    },
    {
      text: "Transactions",
      icon: "transactions",
      to: "/billing/transactions",
      permissions: ["view-bill", "manage-bill", "create-payment", "view-wallet", "super-view"],
    },
    {
      text: "Insight",
      icon: "insight",
      to: "/billing/insight",
      permissions: ["view-bill", "manage-bill", "super-view"],
    },
    {
      text: "Claims",
      icon: "insurance",
      to: "/billing/claims",
      permissions: ["view-claims", "manage-claims", "super-view"],
    },
  ];
  return sidebarOptions;
};

export const reportNavOptions = () => {
  const sidebarOptions = [
    {
      text: "Dashboard",
      icon: "dashboard-fd",
      to: "/report/dashboard",
      permissions: ["view-report", "super-view"],
    },
  ];
  return sidebarOptions;
};

export const subscriptionsNavOptions = () => {
  const sidebarOptions = [
    {
      text: "Dashboard",
      icon: "credit-card",
      to: "/subscriptions/dashboard",
    },
    {
      text: "Integrations",
      icon: "git-branch",
      to: "/subscriptions/integrations",
    },
    {
      text: "SMS",
      icon: "mail",
      to: "/subscriptions/sms",
    },
    {
      text: "Lab Tracking",
      icon: "microscope",
      to: "/subscriptions/lab-tracking",
    },
  ];
  return sidebarOptions;
};
